import store from '../store'

export async function configureDevices(includeCamera=true, includeAudioInput=true, includeAudioOutput=false){
  const cameraDevice = store.state.media.cameraDevice;
  const audioInputDevice = store.state.media.audioInputDevice;
  const audioOutputDevice = store.state.media.audioOutputDevice;
  let mediaDevices;
  try{
     mediaDevices=await navigator.mediaDevices.enumerateDevices();
  }catch (e) {
    throw 'permission';
  }
  const cameraDeviceFound=mediaDevices.find(mediaDevice=>mediaDevice.deviceId===cameraDevice);
  const audioInputDeviceFound=mediaDevices.find(mediaDevice=>mediaDevice.deviceId===audioInputDevice);
  const audioOutputDeviceFound=mediaDevices.find(mediaDevice=>mediaDevice.deviceId===audioOutputDevice);

  if(includeCamera && (!cameraDevice || !cameraDeviceFound)){
     const deviceId=getDefaultDevice(mediaDevices,'videoinput');
     if(deviceId){
        store.dispatch('media/setCameraDevice',deviceId);
     }else{
       throw 'video';
     }
  }

  if(includeAudioInput && (!audioInputDevice || !audioInputDeviceFound)){
    const deviceId=getDefaultDevice(mediaDevices,'audioinput');
    if(deviceId){
      store.dispatch('media/setAudioInputDevice',deviceId);
    }else{
      throw 'audioinput';
    }
  }

  if(includeAudioOutput &&(!audioOutputDevice || !audioOutputDeviceFound)){
    const deviceId=getDefaultDevice(mediaDevices,'audiooutput');
    if(deviceId){
      store.dispatch('media/setAudioOutputDevice',deviceId);
    }else{
      throw 'audiooutput';
    }
  }

  return true;
}

function getDefaultDevice(deviceList,type){
  const devices = deviceList.filter(d => d.kind === type);
  let defaultVideoInput = devices.findIndex(d => d.deviceId === 'default');
  if (defaultVideoInput >= 0) {
    return devices[defaultVideoInput].deviceId;
  } else if (devices.length > 0) {
    return devices[0].deviceId;
  }
  return null;
}


let audioContext;
let analyser;
let microphone;
let scriptProcessor;

import { throttle } from "lodash-es";

const MIC_LEVEL_HISTORY_DURATION = 5000; // 5 seconds in milliseconds
const UPDATE_INTERVAL = 100; // Interval to update the mic level history, in milliseconds
let micLevelHistory = [];
let startTime;

const updateMicLevelHistory = throttle((average) => {
  const now = Date.now();
  micLevelHistory.push({ time: now, level: average });

  // Remove entries older than 5 seconds
  micLevelHistory = micLevelHistory.filter(entry => now - entry.time < MIC_LEVEL_HISTORY_DURATION);
}, UPDATE_INTERVAL);

const updateMicLevelThrottled = throttle((micLevel, funcToCall, micIsAlive) => {
  if (funcToCall) {
    funcToCall(Math.min(100, Math.round(micLevel)), micIsAlive);
  }
}, UPDATE_INTERVAL);

export async function micLevelCheck(deviceId, onLevelUpdated) {
  navigator.mediaDevices.getUserMedia({
    audio: { deviceId: deviceId },
  })
      .then(function (stream) {
        stopMicLevelCheck();

        startTime = Date.now();
        audioContext = new AudioContext();
        analyser = audioContext.createAnalyser();
        microphone = audioContext.createMediaStreamSource(stream);
        scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1);

        analyser.smoothingTimeConstant = 0.8;
        analyser.fftSize = 1024;

        microphone.connect(analyser);
        analyser.connect(scriptProcessor);
        scriptProcessor.connect(audioContext.destination);
        scriptProcessor.onaudioprocess = function () {
          if(!analyser){
            return;
          }
          const array = new Uint8Array(analyser.frequencyBinCount);
          analyser.getByteFrequencyData(array);
          const arraySum = array.reduce((a, value) => a + value, 0);
          const average = arraySum / array.length;

          // Update mic level history at a throttled interval
          updateMicLevelHistory(average);

          // Determine if mic is alive
          const now = Date.now();
          let micIsAlive = true;
          if (now - startTime > MIC_LEVEL_HISTORY_DURATION) {
            micIsAlive = micLevelHistory.some(entry => entry.level > 2); // If any entry in the history is greater than 2, the mic is alive
          }

          updateMicLevelThrottled(average, onLevelUpdated, micIsAlive);
        };
      })
      .catch(function (err) {
        /* handle the error */
        console.error(err);
      });
}

export function stopMicLevelCheck() {
  if (audioContext) {
    audioContext.close();
  }
  if (microphone) {
    microphone.disconnect();
  }
  if (analyser) {
    analyser.disconnect();
  }
  if (scriptProcessor) {
    scriptProcessor.disconnect();
  }
  audioContext = null;
  microphone = null;
  analyser = null;
  scriptProcessor = null;
  micLevelHistory = []; // Reset mic level history
  startTime = null;
}